export default __webpack_public_path__ + "64aac8eb5d0ebe48bc93d96705842e95.png";